import React from 'react';
import { AlertDialog as SharedAlertDialog } from '@packages/ui';

type AlertDialogType = 'warning' | 'danger' | 'info' | 'success';

interface AlertDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  type?: AlertDialogType;
  confirmText?: string;
  onConfirm: () => void;
}

const AlertDialog: React.FC<AlertDialogProps> = ({
  isOpen, title, message, type = 'info', confirmText = '确定', onConfirm,
}) => {
  return (
    <SharedAlertDialog
      isOpen={isOpen}
      title={title}
      message={message}
      type={type}
      confirmText={confirmText}
      onConfirm={onConfirm}
    />
  );
};

export default AlertDialog;
